import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c43d79a8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "news-group-container"
};
const _hoisted_2 = {
  class: "add-account"
};
const _hoisted_3 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "20px"
  }
}, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "10px"
  }
}, "签名审核状态：", -1));
const _hoisted_6 = {
  style: {
    "width": "250px"
  }
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "20px"
  }
}, null, -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "margin-right": "10px"
  }
}, "签名类型：", -1));
const _hoisted_9 = {
  style: {
    "width": "250px"
  }
};
const _hoisted_10 = {
  style: {
    "margin-left": "20px"
  }
};
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = {
  key: 1
};
const _hoisted_13 = {
  key: 2
};
const _hoisted_14 = {
  key: 3
};
import { ref } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { useRoute } from 'vue-router';
import { Search, Refresh } from '@element-plus/icons-vue';
import { getSmsSignNamePage, delSmsSignName, asyncSign } from '@/api/sms';
import usePagination from '@/hooks/usePagination';
import { tableDataSchemas, PLATFORM_TYPE, signStatusOptions, signTypeOptions, SIGN_STATUS, SIGN_TYPE } from './config';
export default {
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const appId = ref(route.params.appId);
    const tableData = ref([]);
    const {
      currentPage,
      total,
      pageSize,
      setCurrentPage,
      setTotal
    } = usePagination();
    // loading效果
    const loading = ref(false);
    const signName = ref('');
    const signStatus = ref('');
    const signType = ref('');
    const handleSignStatusChange = e => {
      signStatus.value = e;
    };
    const handleSignTypeChange = e => {
      signType.value = e;
    };
    const handleRefreshActivity = () => {
      currentPage.value = 1;
      signName.value = '';
      signStatus.value = '';
      signType.value = '';
      getData();
    };

    /*
     * 获取短信接入方密钥分页
     */
    const getData = async () => {
      loading.value = true;
      try {
        const res = await getSmsSignNamePage({
          currentPage: currentPage.value,
          pageSize: pageSize.value,
          appId: appId.value,
          signName: signName.value,
          signStatus: signStatus.value,
          signType: signType.value
        });
        // console.log(res)
        tableData.value = res.records;
        setCurrentPage(res.current);
        setTotal(res.total);
        loading.value = false;
      } catch (error) {
        console.log('error:', error);
        loading.value = false;
      }
    };
    getData();

    /**
     * 更改当前页码
     * @param {*} val
     */
    const handleCurrentChange = val => {
      setCurrentPage(val);
      getData();
    };
    const handleAsyncSign = async () => {
      await asyncSign(appId.value);
      currentPage.value = 1;
      getData();
      ElMessage({
        type: 'success',
        message: '同步成功'
      });
    };
    const handleDel = row => {
      ElMessageBox.confirm('是否删除该短信密钥管理信息', '温馨提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await delSmsSignName(row);
        await getData();
        ElMessage({
          type: 'success',
          message: '删除成功'
        });
      });
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        class: "title-card",
        shadow: "never"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_input, {
          modelValue: signName.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => signName.value = $event),
          placeholder: "短信签名名称",
          style: {
            "width": "300px"
          }
        }, null, 8, ["modelValue"]), _hoisted_4, _hoisted_5, _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_select, {
          modelValue: signStatus.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => signStatus.value = $event),
          class: "m-2",
          placeholder: "选择签名审核状态",
          onChange: handleSignStatusChange
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(signStatusOptions), item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]), _hoisted_7, _hoisted_8, _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_select, {
          modelValue: signType.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => signType.value = $event),
          class: "m-2",
          placeholder: "选择签名类型",
          onChange: handleSignTypeChange
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(signTypeOptions), item => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_button, {
          type: "primary",
          icon: _unref(Search),
          onClick: getData
        }, {
          default: _withCtx(() => [_createTextVNode(" 查询 ")]),
          _: 1
        }, 8, ["icon"]), _createVNode(_component_el_button, {
          icon: _unref(Refresh),
          onClick: handleRefreshActivity
        }, {
          default: _withCtx(() => [_createTextVNode(" 重置 ")]),
          _: 1
        }, 8, ["icon"])])]), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleAsyncSign
        }, {
          default: _withCtx(() => [_createTextVNode(" 同步 ")]),
          _: 1
        })])]),
        _: 1
      }), _createVNode(_component_el_card, {
        shadow: "never"
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: tableData.value,
          style: {
            "width": "100%"
          },
          border: ""
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tableDataSchemas), (item, index) => {
            return _openBlock(), _createBlock(_component_el_table_column, {
              key: index,
              label: item.label,
              "min-width": item.minWidth
            }, {
              default: _withCtx(({
                row
              }) => [item.prop === 'platform' ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(PLATFORM_TYPE)[row[item.prop]]), 1)) : item.prop === 'signStatus' ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_el_tag, {
                type: row[item.prop] === 0 ? 'primary' : row[item.prop] === 1 ? 'success' : 'danger'
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(SIGN_STATUS)[row[item.prop]]), 1)]),
                _: 2
              }, 1032, ["type"])])) : item.prop === 'signType' ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_el_tag, {
                type: row[item.prop] === 0 ? 'primary' : 'success'
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(SIGN_TYPE)[row[item.prop]]), 1)]),
                _: 2
              }, 1032, ["type"])])) : (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(row[item.prop]), 1))]),
              _: 2
            }, 1032, ["label", "min-width"]);
          }), 128)), _createVNode(_component_el_table_column, {
            label: "操作"
          }, {
            default: _withCtx(({
              row
            }) => [_createVNode(_component_el_button, {
              type: "danger",
              onClick: $event => handleDel(row)
            }, {
              default: _withCtx(() => [_createTextVNode(" 删除 ")]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]]), _createElementVNode("div", null, [_createVNode(_component_el_pagination, {
          onCurrentChange: handleCurrentChange,
          "current-page": _unref(currentPage),
          "page-size": _unref(pageSize),
          total: _unref(total),
          layout: "total,  prev, pager, next, jumper",
          style: {
            "margin-top": "10px"
          }
        }, null, 8, ["current-page", "page-size", "total"])])]),
        _: 1
      })]);
    };
  }
};